<div class="footer-nav-block">
    @for (column of columns; track column; let isLast = $last) {
        <h-footer-links-group-deprecated
            [column]="column"
            [isLastColumn]="isLast"
            (triggerToggle)="handleToggleColumn($event, isLast)">
        </h-footer-links-group-deprecated>
    }
</div>
